<template>
    <v-container class="content" >

      <v-row class="justify-center">
        <h1 style="color: #FFFFFF; font-size: 56px;">404</h1>
      </v-row>

      <LoginLogo />

      <v-row no-gutters justify="center" align="center" class="text-center my-5">
        {{$t('routes.notFound.resourceNotFound')}}
      </v-row>

      <v-row no-gutters justify="center" align="center" class="">
        <v-btn type="button" v-on:click="goBack" class="bg-primary">
          <v-icon>mdi-arrow-left</v-icon>
          {{$t('routes.notFound.goBack')}}
        </v-btn>
      </v-row>
    </v-container>
</template>

<script>
import LoginLogo from '../account/components/LoginLogo.vue'

export default {
  name: "NotFoundPage",
  components: {
    LoginLogo,
  },
  methods: {
    goBack: function() {
      this.$router.go(-1);
    }
  }
}
</script>
